import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import { AnnouncementBar, PromoMarquee } from './components/TopBars';
import Hero from './components/Hero';
import Benefits from './components/Benefits';
import Formula from './components/Formula';
import Comparison from './components/Comparison';
import Timeline from './components/Timeline';
import Testimonials from './components/Testimonials';
import BuyBox from './components/BuyBox';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import { Toaster } from './components/ui/toaster';
import { toast } from './hooks/use-toast';

function Home() {
  const [theme, setTheme] = React.useState('light');
  const [announceOpen, setAnnounceOpen] = React.useState(true);
  const [cartOpen, setCartOpen] = React.useState(false);
  const [items, setItems] = React.useState(() => {
    try { return JSON.parse(localStorage.getItem('cv_cart') || '[]'); } catch { return []; }
  });

  React.useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  React.useEffect(() => {
    localStorage.setItem('cv_cart', JSON.stringify(items));
  }, [items]);

  const addToCart = (p) => {
    setItems((arr) => {
      const found = arr.find((it) => it.id === p.id);
      if (found) return arr.map((it) => it.id === p.id ? { ...it, qty: it.qty + (p.qty || 1) } : it);
      return [...arr, { id: p.id, name: p.name, subtitle: p.subtitle, price: p.price, image: p.image, qty: p.qty || 1 }];
    });
    toast({ title: 'Added to cart', description: `${p.name} \u2014 own your strength.` });
    setCartOpen(true);
  };

  const scrollToProduct = () => {
    document.getElementById('product')?.scrollIntoView({ behavior: 'smooth' });
  };

  const cartCount = items.reduce((s, i) => s + i.qty, 0);

  return (
    <div className={`App ${theme === 'dark' ? 'dark' : ''} min-h-screen`}>
      <AnnouncementBar visible={announceOpen} onClose={() => setAnnounceOpen(false)} />
      <PromoMarquee />
      <Header theme={theme} onToggleTheme={() => setTheme((t) => t === 'dark' ? 'light' : 'dark')} onOpenCart={() => setCartOpen(true)} cartCount={cartCount} onShopClick={scrollToProduct} />
      <main className="pb-10">
        <Hero onShopClick={scrollToProduct} />
        <Benefits />
        <Formula />
        <Comparison />
        <Timeline />
        <BuyBox onAddToCart={addToCart} />
        <Testimonials />
        <FAQ />
      </main>
      <Footer />
      <CartDrawer open={cartOpen} onClose={() => setCartOpen(false)} items={items} setItems={setItems} />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
